// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"229425f1","607":"c1afa87b"}[chunkId] + ".chunk.js";
};